import { render } from "./PartnersStatusView.vue?vue&type=template&id=66132b29"
import script from "./PartnersStatusView.vue?vue&type=script&lang=js"
export * from "./PartnersStatusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__